module.exports = __webpack_public_path__ + "static/hackathon-7-0aaf436fa5bddbd422d7c9b88434deac.jpg";